import {logger} from '../../logger';
import s from '../s';
import {SetDocSize} from '../components/doc-sizes-and-categories/doc-size-pulse';
import {allowsAutomatedDocSizes} from '../components/doc-sizes-and-categories/document-sizing';
import {buildSizeQuestions, groupByKey, windowAt} from '../redesign/size-questions';
import type {ProductDocSize} from '../i';

// The automated document size selection, shared by both product page layouts. Moved unchanged from
// components/doc-sizes-and-categories/doc-size-automated.tsx.

export const selectDocSize = async (id: number): Promise<void> => {
    logger.log(id);
    SetDocSize(id);
    s.ui.update_pricing = true;
    s.ui.doRender = true;
    s.pulse();
};

/**
 * The size a school change keeps once the sizes were re-run for the new school (selectLino): the shopper's size when the new school
 * offers it, else the new school's size for the same degree (DocSizeName) at that moment, the row the redesign's degree answer
 * takes, else the first size of the new list.
 */
export const sizeAfterSchoolChange = (available: ProductDocSize[], previous: ProductDocSize | undefined, now: number): ProductDocSize | undefined => {
    if (previous) {
        const same = available.find(x => x.Id === previous.Id);
        if (same) {
            return same;
        }
        const degree = groupByKey(buildSizeQuestions(available), (previous.DocSizeName || '').trim());
        if (degree) {
            const row = windowAt(degree.windows, now).row;
            return available.find(x => x.Id === row.Id);
        }
    }
    return available[0];
};

// ---- view model ------------------------------------------------------------------------------------------------------

/** product.tsx's mount rule for the automated document sizes. */
export const docSizesMounted = (): boolean => !s.IsPortal3 && !!s.prod && s.docsizes_enabled && !!s.docsizes_available;

/** The size tiles show: the store's automated sizes apply and the current school has two or more rows. */
export const docSizeTilesShown = (): boolean => docSizesMounted() && allowsAutomatedDocSizes(s.prod, s.si.AutomatedDocSizes) && !!s.docsizes_available && s.docsizes_available.length >= 2;

/** product.tsx's mount rule for the product's categories (no automated sizes). */
export const categoriesMounted = (): boolean => !s.IsPortal3 && !!s.prod && (!s.docsizes_enabled || !s.docsizes_available);
